import React, { lazy } from 'react'

const AdminPage = lazy(() => import('./AdminPage'))

export { AdminPage }
